export const getPreviewTrackingParams = (previewChecked, previewEnrolled) =>
  previewChecked && previewEnrolled
    ? {
        preview_checked: previewChecked === '1',
        preview_enrolled: previewEnrolled === '1',
        preview_uuid: (window.IH as any).userUuid,
      }
    : {};
